module.exports = __webpack_public_path__ + "static/img/05.e5f86b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/05.png
// module id = ejA3
// module chunks = 0